<script lang="ts">
	export let image: string;
	export let imageSide: string = 'right';

	export let style: string = 'light';

	let offsetClass = imageSide == 'right' ? '' : 'col-md-offset-7 col-sm-offset-5';
	let textColorClass = style == 'light' ? '' : 'white-color';
</script>

<section class="{style}-bg">
	<div class="col-md-6 col-sm-4 bg-flex bg-flex-{imageSide}">
		<div class="bg-flex-holder bg-flex-cover" style="background-image: url({image});" />
	</div>

	<div class="container">
		<div class="col-md-5 col-sm-7 {offsetClass} {textColorClass}">
			<slot />
		</div>
	</div>
</section>
